import React from 'react';
import { Link } from 'react-router-dom';
import './HomeHero.css';
import heroImage from '../../assets/images/gn_bank_cover.jpeg';
import { CUSTOMER_PORTAL_URL } from '../../constants/links';
import IncidentBanner from '../Incident/IncidentBanner';

const HomeHero = () => {
  return (

    <>

    <IncidentBanner/>
  
    <section className="gn-home-hero" aria-label="GN Bank home">
      <div
        className="gn-home-hero__media"
        style={{ backgroundImage: `url(${heroImage})` }}
        role="img"
        aria-label="GN Bank community banking"
      />
      <div className="gn-home-hero__shade" aria-hidden="true" />
      <div className="gn-container">
        <div className="gn-home-hero__content">
          <p className="gn-home-hero__brand">GN Bank</p>
          <h1 className="gn-home-hero__title">Modern community banking, built around you.</h1>
          <p className="gn-home-hero__subtitle">
            Checking, savings, and online banking with the local service you trust.
          </p>


          <div className="gn-home-hero__ctas">
            <a
              className="btn btn-gn-primary"
              href={CUSTOMER_PORTAL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open an account
            </a>
            <Link className="btn btn-gn-secondary btn-gn-on-dark" to="/location">
              Find a location
            </Link>
          </div>
        </div>
      </div>
    </section>
      </>
  );
};

export default HomeHero;
